import Swal from "sweetalert2";

export const viewAlert = (title, message, icon) => {
  Swal.fire({
    title: title,
    text: message,
    icon: icon
  });
}